// extracted by mini-css-extract-plugin
export default {"container":"AlertSettingsPage_container__IXmOt"};